import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import {
  HiChartBar,
  HiDocumentText,
  HiUserGroup,
  HiUsers,
  HiAcademicCap,
  HiChatBubbleLeftRight,
  HiCog6Tooth,
  HiQuestionMarkCircle,
  HiChatBubbleBottomCenterText,
  HiChartBarSquare,
  HiClipboardDocumentList,
  HiDocumentCheck,
  HiChevronLeft,
  HiChevronRight,
  HiMagnifyingGlass,
  HiClipboardDocumentCheck,
  HiMegaphone,
  HiCreditCard,
  HiDocumentMagnifyingGlass,
  HiCalendarDays,
  HiPresentationChartBar,
  HiBars3,
  HiXMark
} from "react-icons/hi2";
import { routes } from "../../../helper/routes";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants";
import DataHandler from "../../../handlers/DataHandler";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const Sidebar = (props) => {
  const [isExpanded, setExpanded] = useState(false);
  const [isMobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const employeeType = sessionStorage.getItem("employeeType");

  const toggleSidebar = () => {
    const newExpandedState = !isExpanded;
    setExpanded(newExpandedState);
    if (props.onToggle) {
      props.onToggle(newExpandedState);
    }
  };

  const toggleMobileSidebar = () => {
    setMobileOpen(!isMobileOpen);
  };

  const closeMobileSidebar = () => {
    setMobileOpen(false);
  };

  const closeSidebar = () => {
    setExpanded(false);
    if (props.onToggle) {
      props.onToggle(false);
    }
  };

  const handleOutsideClick = (event) => {
    const sidebar = document.querySelector(".sidebar");
    const burgerButton = document.querySelector(".mobile-burger-menu");

    if (sidebar && !sidebar.contains(event.target) &&
      burgerButton && !burgerButton.contains(event.target)) {
      if (window.innerWidth > 768) {
        closeSidebar();
      }
      if (window.innerWidth <= 768 && isMobileOpen) {
        closeMobileSidebar();
      }
    }
  };

  useEffect(() => {
    document.body.addEventListener("click", handleOutsideClick);

    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, [isMobileOpen]);

  const renderMenuItem = (to, icon, label, additionalState = {}) => {
    const isActive = location.pathname === to;

    const handleClick = () => {
      if (window.innerWidth <= 768) {
        setMobileOpen(false);
      }
    };

    return (
      <li key={to} className={isActive ? "active" : ""}>
        <Link
          to={{ pathname: to, state: { ...additionalState } }}
          onClick={handleClick}
        >
          {isExpanded ? (
            <>
              <div className="sidebar-icon-wrapper">{icon}</div>
              <span className="sidebar-label">{label}</span>
            </>
          ) : (
            <div className="sidebar-item-collapsed">
              <div className="sidebar-icon-wrapper">{icon}</div>
              <div className="sidebar-icon-label">{label}</div>
            </div>
          )}
        </Link>
      </li>
    );
  };

  const customer = getCustomerFeatureFlag();
  let customerPaperText, customerStudentPaperText, isCMC, isEdFoci;
  switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
      customerPaperText = "Papers";
      customerStudentPaperText = "Exams";
      isCMC = false;
      isEdFoci = false;
      break;
    case customerConstants.EXO_CUSTOMER2:
      customerPaperText = "Past Papers";
      customerStudentPaperText = "Find Past Papers";
      isCMC = true;
      isEdFoci = false;
      break;
    case customerConstants.EDF_CUSTOMER3:
      customerPaperText = "Courses";
      customerStudentPaperText = "Courses";
      isCMC = false;
      isEdFoci = true;
      break;
    default:
      customerPaperText = "Search";
      customerStudentPaperText = "Papers";
      isCMC = false;
      isEdFoci = true;
      break;
  }

  let isASAD = DataHandler.getFromSession("isASAD");

  return (
    <>
      {isMobileOpen && (
        <div
          className="sidebar-overlay"
          onClick={closeMobileSidebar}
        />
      )}

      <nav
        className={`sidebar ${isExpanded ? "expanded" : "collapsed"} ${isMobileOpen ? "mobile-open" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Sidebar Expand/Collapse Icon Toggle Section*/}
        {/* <div className="toggle-container">
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            {isExpanded ? <HiChevronLeft /> : <HiChevronRight />}
          </button>
        </div> 
        */}
        

        <ul className="list-unstyled components">
          {renderMenuItem("/manage-dashboard", <HiChartBar />, "Dashboard")}

          {!isEdFoci && !isCMC && props.isAdmin &&
            renderMenuItem(
              "/search-papers",
              <HiDocumentMagnifyingGlass />,
              "Find" + " " + customerPaperText
            )
          }

          {!(props.isTeacher && (employeeType === "TEACH")) && (!props.isStudent && !props.isParent) &&
            renderMenuItem(
              routes.paper_mapping,
              <HiDocumentText />,
              "Manage Papers",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                nodeTitle: "Manage Papers",
                privilege_view: 1,
                mid: 100,
                main_table_id: 10,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("manage_user_id"),
                lg_user_table_id: sessionStorage.getItem("table_log_id"),
                user_list_restriction: null,
                flg_list_active: 1,
                form_list_id: 10,
              }
            )}

          {!!props.isAdmin &&
            !isEdFoci && !isCMC &&
            renderMenuItem(
              routes.assess_subscriptions,
              <HiCreditCard />,
              "Assessment Subscription",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                nodeTitle: "Assessment Subscription",
                privilege_view: 1,
                mid: 100,
                main_table_id: 2,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("manage_user_id"),
                lg_user_table_id: sessionStorage.getItem("table_log_id"),
                user_list_restriction: null,
                flg_list_active: 1,
                form_list_id: 46,
              }
            )}

          {!!props.isTeacher && (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderMenuItem(
              routes.view_assessment,
              <HiClipboardDocumentList />,
              "Assessments"
            )
          }

          {!isEdFoci && (props.isStudent || props.isParent) &&
            renderMenuItem(
              routes.find_papers,
              <HiDocumentText />,
              customerStudentPaperText
            )
          }
          {!!props.isAdmin &&
            !isEdFoci && !isCMC &&
            renderMenuItem(
              "/manage-invitations",
              <HiChatBubbleLeftRight />,
              "Requests"
            )}

          {!!props.isAdmin &&
            !isEdFoci &&
            renderMenuItem(
              "/manage-teacher",
              <HiPresentationChartBar />,
              "Employees",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                breadcrumb2: "employees",
                nodeTitle: "",
                mid: 100,
                main_table_id: 10,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("table_log_id"),
                lg_user_table_id: sessionStorage.getItem("manage_user_id"),
                user_list_restriction: null,
              }
            )}


          {!!props.isAdmin &&
            !isEdFoci &&
            renderMenuItem("/manage_announcement", <HiPresentationChartBar/>, "Manage Announcements", {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              privilege_view: 1,
              breadcrumb2: "manage_announcement",
              nodeTitle: "",
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("table_log_id"),
              lg_user_table_id: sessionStorage.getItem("manage_user_id"),
              user_list_restriction: null,
              flg_list_active: null,
              node_mid_actual: null,
            })
          }



          {!!props.isAdmin &&
            !isEdFoci &&
            renderMenuItem(
              "/manage-student",
              <HiAcademicCap />,
              "Students",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                breadcrumb2: "Students",
                nodeTitle: "",
                privilege_view: 1,
                mid: 100,
                main_table_id: 2,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("manage_user_id"),
                lg_user_table_id: sessionStorage.getItem("table_log_id"),
                user_list_restriction: null,
              }
            )}

          {!!props.isAdmin &&
            !isCMC &&
            !isEdFoci &&
            renderMenuItem("/manage-parent", <HiUserGroup />, "Parents", {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              breadcrumb2: "parents",
              nodeTitle: "",
              mid: 100,
              main_table_id: 3,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("table_log_id"),
              lg_user_table_id: sessionStorage.getItem("manage_user_id"),
              user_list_restriction: null,
            })}
          {!!props.isTeacher &&
            (employeeType === "DEOP" ||
              employeeType === "MASAD" || employeeType === "TEACH") &&
            renderMenuItem(
              routes.view_assessment_review,
              <HiClipboardDocumentCheck />,
              "Paper Review"
            )
          }

          {
            (employeeType === "MASAD") &&
            renderMenuItem(
              routes.assessment_template,
              <HiDocumentCheck />,
              "Assessment Template"
            )
          }

          {(!!props.isTeacher || !!props.isStudent) &&
            !isEdFoci &&
            renderMenuItem("/announcements", <HiMegaphone />, "Announcements", {
              privilege_edit: props.isTeacher ? 1 : null,
              privilege_add: props.isTeacher ? 1 : null,
              privilege_delete: null,
              privilege_view: 1,
              breadcrumb2: "announcement",
              nodeTitle: "",
              mid: 100,
              main_table_id: props.isTeacher ? 10 : 2,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              flg_list_active: null,
              node_mid_actual: null,
            })
          }

          {(!!props.isParent) &&
            !isEdFoci &&
            renderMenuItem("/announcements", <HiMegaphone />, "Announcements", {
              privilege_edit: props.isTeacher ? 1 : null,
              privilege_add: props.isTeacher ? 1 : null,
              privilege_delete: null,
              privilege_view: 1,
              breadcrumb2: "announcement",
              nodeTitle: "",
              mid: 100,
              main_table_id: props.isTeacher ? 10 : 2,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              flg_list_active: null,
              node_mid_actual: null,
            })
          }


          {!!props.isStudent &&
            !isEdFoci &&
            sessionStorage.getItem("manage_user_id") &&
            renderMenuItem("/assess-subscriptions", <HiCreditCard />, "Assessment Subscriptions", {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              nodeTitle: "Assessment Subscriptions",
              privilege_view: 1,
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              flg_list_active: 1,
              form_list_id: 46,
            })
          }


          {!!props.isParent &&
            !isEdFoci &&
            sessionStorage.getItem("parent_group_id") &&
            sessionStorage.getItem("parent_group_user_table_id") &&
            renderMenuItem("/assess-subscriptions", <HiCreditCard />, "Assessment Subscriptions", {
              privilege_edit: 1,
              privilege_add: 1,
              privilege_delete: 1,
              privilege_view: 1,
              nodeTitle: "Assessment Subscriptions",
              mid: 100,
              main_table_id: 10,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              flg_list_active: 1,
              form_list_id: 46,
            })
          }

          {!!props.isParent &&
            renderMenuItem(
              "/register-student",
              <HiUsers />,
              "Students",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                breadcrumb2: "Student Registration",
                nodeTitle: "",
                mid: 100,
                main_table_id: 10,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("table_log_id"),
                lg_user_table_id: sessionStorage.getItem("manage_user_id"),
                user_list_restriction: null,
              }
            )
          }

          {!!props.isStudent &&
            !isEdFoci &&
            !isCMC &&
            renderMenuItem(
              "/my-requests",
              <HiUserGroup />,
              "Parent Requests",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                breadcrumb2: "Parent Requests",
                nodeTitle: "",
                privilege_view: 1,
                mid: 100,
                main_table_id: 10,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("manage_user_id"),
                lg_user_table_id: sessionStorage.getItem("table_log_id"),
                user_list_restriction: null,
              }
            )
          }

          {!!props.isTeacher && (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderMenuItem(
              routes.questions_library,
              <HiQuestionMarkCircle />,
              "Questions"
            )
          }

          {
            (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderMenuItem(
              routes.question_passage,
              <HiChatBubbleBottomCenterText />,
              "Question Passages"
            )
          }

          {!isEdFoci && !isCMC && (props.isAdmin || (!!props.isTeacher && employeeType === "MASAD")) &&
            renderMenuItem(
              routes.search_question,
              <HiChartBarSquare />,
              "Question Statistics"
            )
          }

          {!!props.isAdmin &&
            renderMenuItem("/user-reports", <HiClipboardDocumentList />, "Reports")
          }


          {!!props.isAdmin &&
            renderMenuItem("/manage-settings", <HiCog6Tooth />, "Settings")
          }

          {!!props.isTeacher && (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderMenuItem(routes.settings_view, <HiCog6Tooth />, "Settings")
          }

          {isEdFoci &&
            renderMenuItem("/manage-sitemap", <HiDocumentCheck />, "Site Map")
          }

          {isEdFoci &&
            renderMenuItem("/main-calendar", <HiCalendarDays />, "Calendar")
          }
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;